module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen Draw.f9841928.JPG";